import { render } from "./SetPlatFormLevelAuth.vue?vue&type=template&id=17a9fe7e&scoped=true"
import script from "./SetPlatFormLevelAuth.vue?vue&type=script&lang=js"
export * from "./SetPlatFormLevelAuth.vue?vue&type=script&lang=js"

import "./SetPlatFormLevelAuth.vue?vue&type=style&index=0&id=17a9fe7e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17a9fe7e"]])

export default __exports__